const localStorageUtil = {
  setItem: (key, value) => {
    const serializedValue = JSON.stringify(value);
    localStorage.setItem(key, serializedValue);
  },

  getItem: key => {
    const value = localStorage.getItem(key);

    if (value === 'undefined') {
      return undefined;
    }
    return value ? JSON.parse(value) : null;
  },

  removeItem: key => {
    localStorage.removeItem(key);
  },

  clear: () => {
    localStorage.clear();
  },
};

export default localStorageUtil;
